import React from "react";

import { Dropdown as DSDropdown } from "@packages/ds";

import { sendPendoEventDropdownItem } from "Store/analytics/pendoFunctions";

import type { DropdownItemProps } from "@packages/ds";

interface ConsoleItemProps extends Omit<DropdownItemProps, "ref"> {
  analyticId?: string;
  ref?: React.ForwardedRef<HTMLDivElement>;
}

const Item = React.forwardRef<HTMLDivElement, ConsoleItemProps>(function Item(
  { onClick, analyticId, children, onSelect, ...props },
  ref
) {
  const handleSelect = event => {
    if (analyticId) {
      sendPendoEventDropdownItem({
        analyticId,
        type: "item"
      });
    }

    if (onSelect) {
      onSelect(event);
    }
  };

  const handleClick = e => {
    if (onClick) {
      onClick(e);
    }
  };

  return (
    <DSDropdown.Item
      data-pendo-identifier={analyticId}
      onClick={props?.disabled ? undefined : handleClick}
      onSelect={handleSelect}
      ref={ref}
      {...props}
    >
      {children}
    </DSDropdown.Item>
  );
});

export default Item;
